import { Button, Stack } from "@mui/material";
import Box from "@mui/material/Box";
import type { ColumnsType } from "antd/es/table";
import Table from "antd/es/table";
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import NewButton from "../../components/Buttons/NewButton";
import { Desc, Title } from "../../components/Desc";
import ProgressIndicator from "../../components/ProgressIndicator";
import BasicMenu from "../../components/menu/BasicMenu";
import strings from "../../config/localization";
import { useGetResAssQuery } from "../../services/appln";
import { doesPermissionExist } from "../util";
import DeleteResourceAssessment from "./DeleteResourceAssessment";
import EditResourceAssessment from "./EditResourceAssessment";
import NewResourceAssessment from "./NewResourceAssessment";

interface ResourceAssessment {
  key: string;
  resource: string;
  count: string;
}

interface Data {
  rowData: ResourceAssessment[];
  columnData: ColumnsType<ResourceAssessment>;
}

export default function ListResourceAssessments() {
  const params = useParams();
  console.log("ListResourceAssessments, params:", params);

  const [data, setData] = React.useState<Data>({
    rowData: [],
    columnData: [],
  });

  const navigate = useNavigate();

  const [newDialogOpen, setNewDialogOpen] = React.useState(false);

  const bandobastContext = JSON.parse(localStorage.getItem("bandobast")!);
  const timeslotContext = JSON.parse(localStorage.getItem("timeslot")!);
  const locationContext = JSON.parse(localStorage.getItem("location")!);

  const getParams = {
    bandobastId: params.bandobastId,
    timeslotId: params.timeslotId,
    locationId: params.locationId,
  };

  const columns: ColumnsType<ResourceAssessment> = [
    {
      title: strings.resourceType,
      dataIndex: "resourceTypeName",
      key: "resourceTypeName",
    },
    {
      title: strings.count,
      dataIndex: "count",
      key: "count",
    },
    {
      title: "",
      dataIndex: "menu",
      key: "menu",
      render: (text, record, index) => {
        const options = [
          [
            null,
            <Stack direction={"column"} spacing={1}>
              {doesPermissionExist("update-resource-assessment") && (
                <EditResourceAssessment
                  bandobastId={params.bandobastId!}
                  timeslotId={params.timeslotId!}
                  locationId={params.locationId!}
                  resourceAssessmentId={record.key}
                  initialValues={record}
                />
              )}
              {doesPermissionExist("delete-resource-assessment") && (
                <DeleteResourceAssessment
                  bandobastId={params.bandobastId!}
                  timeslotId={params.timeslotId!}
                  locationId={params.locationId!}
                  resourceAssessmentId={record.key}
                />
              )}
            </Stack>,
            null,
            "locations",
            "action",
          ],
        ];
        return (
          <BasicMenu
            action={strings.actions}
            options={options}
            data={record}
            type="location"
          />
        );
      },
    },
  ];

  const resourceAssessmentQueryResponse = useGetResAssQuery(getParams);

  console.log(
    "ListResourceAssessments, resourceAssessmentQueryResponse:",
    resourceAssessmentQueryResponse,
  );

  React.useEffect(() => {
    if (!resourceAssessmentQueryResponse.isSuccess) {
      return;
    }

    const rowData = resourceAssessmentQueryResponse.data.data
      .map((e: any) => {
        return {
          key: e.id,
          resourceTypeName: e.resourceTypeName,
          count: e.count,
        };
      })
      .toSorted((x: any, y: any) => {
        return x.resourceTypeName.localeCompare(y.resourceTypeName);
      });

    setData({ rowData: rowData, columnData: columns });
  }, [resourceAssessmentQueryResponse]);

  return (
    <div>
      <Box>
        {(resourceAssessmentQueryResponse.isLoading ||
          resourceAssessmentQueryResponse.isFetching) && <ProgressIndicator />}
        <Stack spacing={2} style={{ alignItems: "flex-start" }}>
          <Title text={strings.resourceAssessments} />
          {/* <Stack spacing={0}>
            <Desc label={strings.bandobast} value={bandobastContext.name} />
            <Desc label={strings.timeslot} value={timeslotContext.name} />
            <Desc label={strings.location} value={locationContext.name} />
          </Stack> */}
          {doesPermissionExist("add-resource-assessment") && (
            <>
              <NewButton
                onClickHandler={() => {
                  setNewDialogOpen(true);
                }}
              />
              <NewResourceAssessment
                bandobastId={params.bandobastId!}
                timeslotId={params.timeslotId!}
                locationId={params.locationId!}
                onSubmitHandler={(newObj: any) => {
                  setNewDialogOpen(false);
                }}
                onCancelHandler={() => {
                  setNewDialogOpen(false);
                }}
                state={newDialogOpen}
              />
            </>
          )}
          <Table
            virtual
            scroll={{ y: 600 }}
            columns={columns}
            dataSource={data.rowData}
            pagination={false}
          />
          <Button
            variant="contained"
            onClick={(e) => {
              e.preventDefault();
              navigate(-1);
            }}
          >
            {strings.back}
          </Button>
        </Stack>
      </Box>
    </div>
  );
}
